// Works out what a revised quote means financially for a programme already paid / running.
export const PROTECTED_STAGES = ["executing", "invoicing", "reporting", "completed"];

export interface InvoiceLike {
  amount: number | null;
  amount_received?: number | null;
  status: string;
}

export function revisedQuoteFinance(newTotal: number, invoices: InvoiceLike[]) {
  const invoiced = invoices.reduce((s, i) => s + Number(i.amount || 0), 0);
  const paid = invoices
    .filter((i) => i.status === "paid")
    .reduce((s, i) => s + Number(i.amount_received ?? i.amount ?? 0), 0);
  const diff = Math.round((newTotal - invoiced) * 100) / 100;
  return {
    invoiced,
    paid,
    topUpDue: diff > 0.009 ? diff : 0,
    overInvoiced: diff < -0.009 ? -diff : 0,
  };
}

export function keepsStage(status: string, hasPaidInvoice: boolean) {
  return hasPaidInvoice && PROTECTED_STAGES.includes(status);
}
